import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React from 'react';
import { Link } from 'react-router-dom';

import CONSTANT from './../../constant';
import { onChange, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);

        const detail = props.detail;
        this.state = {
            code: detail ? detail.code : undefined,
            name: { name: 'name', value: detail ? detail.name : '', error: '', isRequired: true },
            available: { name: 'available', value: detail ? detail.available : false, error: '', isRequired: true },
        }
        
    }

    render() {
        const { name, available } = this.state;
        
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={this.onSubmit}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className={name.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                placeholder="Noting name"
                                                name={name.name}
                                                value={name.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 form-group">
                                        <label>Available *</label>
                                        <Toggle
                                            defaultChecked={available.value}
                                            onText="Yes"
                                            offText="No"
                                            onChange={this.onToggle}
                                            id={available.name}
                                        />
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <Link to={CONSTANT.component.adminNoting.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                    </div>
                                    <div className="col-md-6">
                                        &nbsp;
                                                </div>
                                    <div className="col-md-3">
                                        <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onToggle = (e: any, checked?: boolean) => {
        const name = e.target.id;
        const value = checked;
        onChange(this, name, value)
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;

            const model: any = {
                name: st.name.value,
                available: st.available.value,
            }

            if (st.code) {
                model.code = st.code
            }

            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;